import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=a5f4dae0&scoped=true&"
import script from "./SubscriptionCard.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f4dae0",
  null
  
)

export default component.exports